import "./styles.css";
import { Box } from "@mui/material";

const CardsGroupComponent = ({ children }) => {
  return (
    <Box className="cards">
      <Box className="card-1">
        <Box className="color-strip"></Box>
        <Box className="card-content">{children}</Box>
      </Box>
      <Box className="card-3"></Box>
      <Box className="card-4"></Box>
    </Box>
  );
};

export default CardsGroupComponent;
